export default __webpack_public_path__ + "static/media/151-plumbering.8845bcd6.png";